import { render, staticRenderFns } from "./LiveBlogroll.vue?vue&type=template&id=0c7f77f8&scoped=true&"
import script from "./LiveBlogroll.vue?vue&type=script&lang=js&"
export * from "./LiveBlogroll.vue?vue&type=script&lang=js&"
import style0 from "./LiveBlogroll.vue?vue&type=style&index=0&id=0c7f77f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7f77f8",
  null
  
)

component.options.__file = "LiveBlogroll.vue"
export default component.exports